import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {
  /**
   * Transform
   *
   * @param {any[]} items
   * @param {string} searchText
   * @param {string} key
   *
   * @returns {any}
   */
  transform(items: any[], searchText: string, key: string): any[] {
    if (!items) return [];
    if (!searchText) return items;

    searchText = searchText.toLowerCase();
    return items.filter(it => {
      return (key ? it[key] : it).toLowerCase().includes(searchText);
    });
  }
}
